import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 自营协议 - 签订方式
 * 与「合同管理」区分，独立协议域枚举
 * 注：value 沿用协议域约定，联调时与 SRM 后台协议管理对齐
 */
const agreementSigningTypeList = [
  { label: '纸质协议', value: '1' },
  { label: '全电子协议', value: '2' },
  { label: '我方电子对方纸质', value: '3' },
] as const

export type AgreementSigningType = ValueOf<typeof agreementSigningTypeList>
export const agreementSigningTypeEnum = customCreateEnum(
  agreementSigningTypeList,
)

/**
 * 自营协议 - 协议签署状态
 */
const agreementSignStatusList = [
  { label: '双方已签署', value: '1' },
  { label: '未签署', value: '2' },
  { label: '我方已签署', value: '3' },
] as const

export type AgreementSignStatus = ValueOf<typeof agreementSignStatusList>
export const agreementSignStatusEnum = customCreateEnum(agreementSignStatusList)

/**
 * 自营协议 - 协议状态
 */
const agreementStatusList = [
  { label: '生效', value: '1' },
  { label: '失效', value: '2' },
  { label: '无效', value: '3' },
] as const

export type AgreementStatus = ValueOf<typeof agreementStatusList>
export const agreementStatusEnum = customCreateEnum(agreementStatusList)

/**
 * 自营协议 - 附件审核状态（label 即页面展示文案）
 * 无效：无审核记录（未上传，内部态，不直接展示）
 * 审核中：H0 审批中
 * 审核驳回：H0 审批驳回，供应商可重新上传
 * 审核通过：审核通过，展示归档附件
 */
const agreementFileReviewStateList = [
  { label: '无效', value: '1' },
  { label: '审核中', value: '2' },
  { label: '审核驳回', value: '3' },
  { label: '审核通过', value: '4' },
] as const

export type AgreementFileReviewState = ValueOf<
  typeof agreementFileReviewStateList
>
export const agreementFileReviewStateEnum = customCreateEnum(
  agreementFileReviewStateList,
)
/**
 * e签宝流程签署状态：0 待发起 / 1 签署中 / 2 签署失败 / 3 已签署
 */
const eSignProcessStatusSelfList = [
  { label: '待发起', value: '0' },
  { label: '签署中', value: '1' },
  { label: '签署失败', value: '2' },
  { label: '已签署', value: '3' },
] as const

export type ESignProcessStatusSelf = ValueOf<typeof eSignProcessStatusSelfList>
export const eSignProcessStatusSelfEnum = customCreateEnum(
  eSignProcessStatusSelfList,
)
import { ValueOf } from '@xhgj/xh-jsutils'
import { customCreateEnum } from './enumArray'

/**
 * 自营协议 - 签订方式
 * 与「合同管理」区分，独立协议域枚举
 * 注：value 沿用协议域约定，联调时与 SRM 后台协议管理对齐
 */
const agreementSigningTypeList = [
  { label: '纸质协议', value: '1' },
  { label: '全电子协议', value: '2' },
  { label: '我方电子对方纸质', value: '3' },
] as const

export type AgreementSigningType = ValueOf<typeof agreementSigningTypeList>
export const agreementSigningTypeEnum = customCreateEnum(
  agreementSigningTypeList,
)

/**
 * 自营协议 - 协议签署状态
 */
const agreementSignStatusList = [
  { label: '双方已签署', value: '1' },
  { label: '未签署', value: '2' },
  { label: '我方已签署', value: '3' },
] as const

export type AgreementSignStatus = ValueOf<typeof agreementSignStatusList>
export const agreementSignStatusEnum = customCreateEnum(agreementSignStatusList)

/**
 * 自营协议 - 协议状态
 */
const agreementStatusList = [
  { label: '生效', value: '1' },
  { label: '失效', value: '2' },
  { label: '无效', value: '3' },
] as const

export type AgreementStatus = ValueOf<typeof agreementStatusList>
export const agreementStatusEnum = customCreateEnum(agreementStatusList)

/**
 * 自营协议 - 附件审核状态（label 即页面展示文案）
 * 无效：无审核记录（未上传，内部态，不直接展示）
 * 审核中：H0 审批中
 * 审核驳回：H0 审批驳回，供应商可重新上传
 * 审核通过：审核通过，展示归档附件
 */
const agreementFileReviewStateList = [
  { label: '无效', value: '1' },
  { label: '审核中', value: '2' },
  { label: '审核驳回', value: '3' },
  { label: '审核通过', value: '4' },
] as const

export type AgreementFileReviewState = ValueOf<
  typeof agreementFileReviewStateList
>
export const agreementFileReviewStateEnum = customCreateEnum(
  agreementFileReviewStateList,
)
/**
 * e签宝流程签署状态：0 待发起 / 1 签署中 / 2 签署失败 / 3 已签署
 */
const eSignProcessStatusSelfList = [
  { label: '待发起', value: '0' },
  { label: '签署中', value: '1' },
  { label: '签署失败', value: '2' },
  { label: '已签署', value: '3' },
] as const

export type ESignProcessStatusSelf = ValueOf<typeof eSignProcessStatusSelfList>
export const eSignProcessStatusSelfEnum = customCreateEnum(
  eSignProcessStatusSelfList,
)
